import {createSlice} from '@reduxjs/toolkit'

const initialOrderState = {
  order: null,
  ordersDropdown: [],
  categoryType: [],
  countryList: [],
  vidsList: [],
  isOrderAPICalledByID: false,
}

export const OrderSlices = createSlice({
  name: 'orders',
  initialState: initialOrderState,
  reducers: {
    order: (state, action) => {
      state.order = action.payload.order
    },
    ordersDropdown: (state, action) => {
      state.ordersDropdown = action.payload.orders
    },
    categoryType: (state, action) => {
      state.categoryType = action.payload.products
    },
    countryList: (state, action) => {
      state.countryList = action.payload.countries
    },
    vidsList: (state, action) => {
      state.vidsList = action.payload.vids
    },
    setIsOrderAPICalledByID: (state, action) => {
      state.isOrderAPICalledByID = action.payload
    },
  },
})
